import { LabelValuePairsType } from 'core/types/common';
import { DynamicObjectType } from 'types/commons';

export const DATA_FIELD_SEARCH: LabelValuePairsType = [
  {
    label: 'Order ID',
    value: 'orderNumber',
    searchKeys: ['orderNumber'],
  },
  {
    label: 'SO',
    value: 'saleOrderId',
    searchKeys: ['saleOrderId'],
  },
  {
    label: 'SKU',
    value: 'sku',
    searchKeys: ['sku'],
  },
  {
    label: 'Shipping Phone',
    value: 'customerPhone',
    searchKeys: ['phone'],
  },
  {
    label: 'Email',
    value: 'email',
    searchKeys: ['email'],
  },
  {
    label: 'Customer name',
    value: 'customerName',
    searchKeys: ['customerName'],
  },
  {
    label: 'Shipping No',
    value: 'deliveryCode',
    searchKeys: ['deliveryCode'],
  },
];

export const DATA_PICK_PACK_FIELD_SEARCH: LabelValuePairsType = [
  {
    label: 'Order ID',
    value: 'orderNumber',
    searchKeys: ['orders.orderNumber'],
  },
  {
    label: 'SO',
    value: 'saleOrderId',
    searchKeys: ['orders.saleOrderId'],
  },
  {
    label: 'SKU',
    value: 'sku',
    searchKeys: ['orderBatch.batchItems.variantSku'],
  },
  {
    label: 'Shipping Phone',
    value: 'customerPhone',
    searchKeys: ['phone'],
  },
  {
    label: 'Email',
    value: 'email',
    searchKeys: ['email'],
  },
  {
    label: 'Customer name',
    value: 'customerName',
    searchKeys: ['customerName'],
  },
  {
    label: 'Shipping No',
    value: 'deliveryCode',
    searchKeys: ['orders.deliveryCode'],
  },
];

export const DATA_ORDERLIST_PICK_PACK_FIELD_SEARCH: LabelValuePairsType = [
  {
    label: 'Order ID',
    value: 'orderNumber',
    searchKeys: ['orderNumber'],
  },
  {
    label: 'SO',
    value: 'saleOrderId',
    searchKeys: ['saleOrderId'],
  },
  {
    label: 'SKU',
    value: 'sku',
    searchKeys: ['sku'],
  },
  {
    label: 'Shipping Phone',
    value: 'customerPhone',
    searchKeys: ['phone'],
  },
  {
    label: 'Email',
    value: 'email',
    searchKeys: ['email'],
  },
  {
    label: 'Customer name',
    value: 'customerName',
    searchKeys: ['customerName'],
  },
  {
    label: 'Shipping No',
    value: 'deliveryCode',
    searchKeys: ['deliveryCode'],
  },
];

export const SEARCH_VALUE = {
  all: '',
  CONFIRMATION: [
    {
      value: 'AWAITING_CONFIRMATION',
      text: 'orderStatus.awaitingConfirmation',
    },
    {
      value: 'CONFIRMED',
      text: 'orderStatus.confirmed',
    },
  ],
  PROCESSING: [
    {
      value: 'READY_TO_PICK',
      text: 'orderStatus.readyToPick',
    },
    {
      value: 'PICKING',
      text: 'orderStatus.picking',
    },
    {
      value: 'PACKING',
      text: 'orderStatus.packing',
    },
    {
      value: 'READY_TO_HANDOVER',
      text: 'orderStatus.readyToHandover',
    },
  ],
  DELIVERING: [
    {
      value: 'DELIVERING',
      text: 'orderStatus.delivering',
    },
    {
      value: 'FAILED_DELIVERY',
      text: 'orderStatus.failedDelivery',
    },
    {
      value: 'RETURNING',
      text: 'orderStatus.returning',
    },
    {
      value: 'LOST',
      text: 'orderStatus.lost',
    },
    {
      value: 'REJECTED',
      text: 'orderStatus.rejected',
    },
  ],
  FAIL_QC: [],
  PENDING: [
    {
      value: 'MANUALLY_PENDING',
      text: 'orderStatus.manuallyPending',
      countKey: 'MANUALLY_PENDING',
    },
    {
      value: 'AUTOMATICALLY_PENDING',
      text: 'orderStatus.automaticallyPending',
    },
    {
      value: 'EXCHANGE_PENDING',
      text: 'orderStatus.pendingForExchange',
      endpoint: '/orders-exchange',
    },
    // {
    //   value: 'PENDING_FOR_TAB_TRY_BUY',
    //   text: 'orderStatus.pendingForTabTryBuy',
    // },
  ],
};

export const CUSTOMER_TABS: DynamicObjectType[] = [
  {
    text: 'All',
    value: 'all',
    subValue: '',
  },
  {
    text: 'Confirmation',
    value: 'CONFIRMATION',
    subValue: ['AWAITING_CONFIRMATION', 'CONFIRMED'],
  },
  {
    text: 'Processing',
    value: 'PROCESSING',
    subValue: ['PICKING', 'PACKING', 'READY_TO_HANDOVER', 'READY_TO_PICK'],
  },
  {
    text: 'Delivering',
    value: 'DELIVERING',
    subValue: [
      'DELIVERING',
      'FAILED_DELIVERY',
      'RETURNING',
      'LOST',
      'REJECTED',
    ],
  },
  {
    text: 'Fail QC',
    value: 'FAIL_QC',
    subValue: ['FAIL_QC'],
  },
  {
    text: 'Pending',
    value: 'PENDING',
    subValue: [
      'PENDING',
      // 'PENDING_PROCESSING',
      'MANUALLY_PENDING',
      'AUTOMATICALLY_PENDING',
      'EXCHANGE_PENDING',
      'PENDING_FOR_TAB_TRY_BUY',
    ],
  },
];
